import { leaveCentralDePrivacidade } from 'common'
import { useLocation, useNavigate } from 'react-router-dom'

export const useNavigator = () => {
  const location = useLocation()
  const navigate = useNavigate()

  function goTo(route: string) {
    if (location.pathname === '/') leaveCentralDePrivacidade()
    else navigate(route)
  }

  const navigateBack = () =>
    location.pathname === '/' ? leaveCentralDePrivacidade() : navigate(-1)

  return { goTo, navigateBack }
}
